import { map, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { INotificationApiDependencySegment } from '@cbridge-packages/api-notifications';
import { catchApiError } from '@cbridge-packages/api-base';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { AlertSubscriptionAction } from '../alertSubscription.action';

type IDependencies = INotificationApiDependencySegment;

export const addEmailEpic: IEpic<{}, IDependencies> = (action$, _state$, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(AlertSubscriptionAction.addEmail.started),
  switchMap((payload) => dependencies.nsApi
    .updateEmails({
      action: 'ADD',
      email: payload.email,
    })
    .pipe(
      map(() => AlertSubscriptionAction.addEmail.done({ params: payload, result: undefined })),
      catchApiError((error) => [
        AlertSubscriptionAction.addEmail.failed({ params: payload, error }),
        createApiErrorNotification(error),
      ]),
    ),
  ),
);
